<div *ngIf="bpForm" class="row" id="parent-brouillon">
    <form focusInvalidInput [formGroup]="bpForm" (ngSubmit)="validate()" [class]="(this.bp.cycleBps ?  this.bp.cycleBps.length > 1 : false ) ? 'col-sm-10' : 'col-sm-12'">
        <div class="row">
            <div class="col-sm-12" style="display: flex; justify-content: space-between;">
                <h3 class="col-sm-6">  Création du {{this.bp.code}} {{this.bp.societe ? '('+ this.bp.societe.code + ')' :''}} </h3>
                <div class="col-sm-6" style="justify-content: space-between;">
                    <button color="default" mat-raised-button type="button" (click)="close()">
                        <mat-icon>arrow_back</mat-icon>Retour à la liste
                    </button>
                    <button color="success" mat-raised-button type="button" (click)="memorize()">
                        <mat-icon>save</mat-icon>Mémoriser
                    </button>
                    <button color="success" mat-raised-button type="submit">
                        <mat-icon>check</mat-icon>Envoyer en validation
                    </button>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12"> 
                <app-bp-form [form]="bpForm" [detailInfo]="detailBpInfo" [amountHT]="bpLineHTs" [amountTTC]="bpLineTTCs"
                [amountTVA]="bpLineTVAs" (uploadDocument)="getSelectedDocuments($event)"></app-bp-form>
            
                <br/>
                <mat-card>
                    <mat-card-content>
                        <app-bp-line-list-array [form]="bpForm" (selected)="changeAnnule($event)" 
                        (amountTVAsEmit)="calculateTvas($event)" (amountHTsEmit)="calculateHorsTaxes($event)"
                        (amountTTCsEmit)="calculateTtcs($event)"></app-bp-line-list-array>
                    </mat-card-content>
                </mat-card>
            </div>
        </div>
    </form>
    <div *ngIf="this.bp.cycleBps ? this.bp.cycleBps.length > 1 : false" class="col-sm-2"> 
        <app-cycles-bp [cycles]="bp.cycleBps" [title]="bp.code"></app-cycles-bp> 
    </div>
</div>
<div *ngIf="bpForm === null">
    <div class="row">
        <div class="col-sm-12" style="display: flex; justify-content: space-between;">
            <h2 class="col-sm-6"> Création de bon à payer </h2>
            <div class="col-sm-6" style="display: flex; justify-content: space-between;">
                <button disabled >
                    <mat-icon>cancel</mat-icon>Fermer
                </button>
                <button disabled >
                    <mat-icon>print</mat-icon>Imprimer
                </button>
                <button disabled >
                    <mat-icon>save</mat-icon>Mémoriser
                </button>
                <button disabled mat-raised-button>
                    <mat-icon>check</mat-icon>Envoyer en validation
                </button>
            </div>
        </div>
    </div>
    <div>
        <mat-spinner class ="spinner" mode="indeterminate"></mat-spinner>
    </div>
</div>
